module.exports = __webpack_public_path__ + "static/media/you-collected-logo.1fd3d3e4.png";